import React from 'react';
import BackButton from '../components/BackButton';
import AstrocyteMetalayer from '../components/AstrocyteMetalayer';

function AstrocyteMetalayerPage() {
  return (
    <>
      <div style={{ height: '80px' }} />
      <BackButton />
      <AstrocyteMetalayer />
    </>
  );
}

export default AstrocyteMetalayerPage;
